<template>
    <div>

        <!-- Table -->

        <trax-ui-ajax-simple-table 
            :id="id" :header="header" :header-color="headerColor" :titles="titles"
            :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-ajax-simple-table>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-registration-phases' },
            targetId: { default: 'enac-atpl-dashboard-registration-program' },
            header: { default: 0 },
            headerColor: { default: 'info' },
            titles: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                endpoint: app_url+'polaris/api/front/registrations/' + data.registration.id,
                endpointParams: {
                    accessors: ['phases']
                },
                endpointExportItems: app_url+'polaris/api/front/export/learners/'+data.learner.id+'/registrations/'+data.registration.id,
                learner: data.learner,
                registration: data.registration,
                aggregation_dashboard_routes: data.aggregation_dashboard_routes,
                cols: [
                    {width: '35px'},
                    {},
                    {class: 'text-right'},
                ],
                rows: [],
                phases : null,
                items : null,
                generationActive: false,
                bus: this.$bus
            }
        },

        computed: {

            exportPermission: function() {
                return this.user.admin || this.user.permissions['export.generate'];
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);

            // The full generation rewrites every phase file: no button here may act meanwhile.
            this.bus.$on(this.targetId+'-generation-active', this.setGenerationActive);

            this.getStates();
        },

        mounted: function() {
            var that = this;
            $('body').on("click", "#"+this.id+"-table button.ajax-button", function() {
                var endpoint = $(this).data('endpoint');
                that.bus.$emit('loader-start-loading');
                axios.post(endpoint)
                    .then(function (response) {
                        that.setStates(response.data.data);
                        that.bus.$emit('loader-stop-loading');
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                    });
            });
        },

        methods: {
        
            getStates() {
                var that = this;
                axios.get(this.endpointExportItems)
                    .then(function (response) {
                        that.setStates(response.data.data);
                        that.bus.$emit(that.targetId+'-states', response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            setStates(items) {
                this.items = items;
                if (this.phases) this.updateRows();
            },

            setData(data) {
                this.phases = data.data.phases;
                if (this.items) this.updateRows();
            },

            setGenerationActive(active) {
                if (this.generationActive === active) return;
                this.generationActive = active;
                if (this.phases && this.items) this.updateRows();
            },

            // The rows are HTML strings: this is how their buttons get disabled.
            busyAttr() {
                return this.generationActive ? 'disabled' : '';
            },

            updateRows() {
                this.rows = [];
                for (var index in this.phases) {
                    var phase = this.phases[index];
                    this.rows.push([
                        this.num(phase, index),
                        this.name(phase),
                        this.buttons(phase),
                    ]);
                }
            },

            num(phase, index) {
                var html = parseInt(index)+1;
                return this.link(phase, html);
            },

            name(phase) {
                var html = phase.name;
                if (this.location(phase)) {
                    html += '<br><small>'+this.location(phase)+'</small>';
                }
                return this.link(phase, html);
            },

            location(phase) {
                if (phase.custom && phase.custom.location) {
                    return phase.custom.location.name
                } else if (phase.location) {
                    return phase.location.name
                } else {
                    return ''
                }
            },

            link(phase, content) {
                var routes = this.aggregation_dashboard_routes;
                var href = routes[phase.type]+'/registration/'+this.registration.id+'/'+phase.type+'/'+phase.id+'/learner/'+this.learner.id;
                return '<a href="'+href+'">'+content+'</a>';
            },

            buttons(phase) {
                var progress;
                for(var index in this.items) {
                    var item = this.items[index];
                    if (item.phase_id == phase.id && item.type == 'phase_progress') {
                        progress = item;
                    }
                }
                return this.preview(phase) + this.generate(phase, progress) + this.download(phase, progress);
            },

            preview(phase) {
                if (!this.exportPermission) return '';
                var href = this.app_url+'polaris/ui/atpl-dashboard/registration/'+this.registration.id+'/'+phase.type+'/'+phase.id+'/learner/'+this.learner.id+'/export/preview';
                var html = '<a href="'+href+'" target="_blank" class="btn btn-white btn-sm ml-1">' + lang.polaris.dashboard.preview + '</a>';
                return html;
            },

            // The document and its attachments are generated together: they are the phase file.
            generate(phase, item) {
                if (!this.exportPermission) return '';
                var endpoint = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/phases/'+phase.id;
                var html = '<button type="button" data-endpoint="'+endpoint+'" '+this.busyAttr()+' class="btn btn-white btn-sm ml-1 ajax-button">';
                html += lang.polaris.dashboard.generate + ' ' + lang.polaris.dashboard.pdf_and_attachments;
                if (item) html += '<br><small>' + this.compactTimestamp(item.updated_at) + '</small>';
                html += '</button>';
                return html;
            },

            download(phase, item) {
                var href = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/phases/'+phase.id+'/file';
                var disabled = item && !this.generationActive ? '' : 'disabled';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download + ' PDF';
                html += '</button>';
                return html;
            },

            compactTimestamp(timestamp) {
                return moment(timestamp).format('DD/MM/YYYY H:mm:ss');
            }
        }
    }
</script>
